const l={light:"light",blue:"blue"};export{l as themes};
//# sourceMappingURL=checkbox.types.js.map
